import React, { useMemo } from "react";
import { Trash } from "react-bootstrap-icons"; // or whatever you use for the trash icon
import SortableTable from "../Table/SortableTable";
import Button from "../UIButton/UIButton";
import SubscriptionDisplay from "../SubscriptionDisplay/SubscriptionDisplay";
import "./deviceDataTable.css";


const DeviceDataTable = ({
    data,
    isLoading,
    onEditClick,
    onDeleteClick
}) => {
  
    const columns = useMemo(
        () => [
            {
                property: "deviceName",
                header: "DEVICE NAME",
                sortable: true,
            },
            {
                property: "description",
                header: "DEVICE DESCRIPTION",
                sortable: true,
            },
            {
                property: "locationName",
                header: "LOCATION NAME",
                sortable: true,
            },
            {
                property: "udid",
                header: "UDID",
                sortable: true,
            },
            {
                property: "serialNumber",
                header: "SERIAL NUMBER",
                sortable: true,
            },
            {
                property: "subscriptionStatus",
                header: "LICENSE STATUS",
                sortable: true,
                custom: (value, row) => {
                    return <SubscriptionDisplay status={row?.subscriptionStatus} type={row?.deviceType} />
                },
            },
            {
                header: "ACTIONS",
                custom: (value, row) => (
                    <div className="d-flex align-items-center gap-2">
                        <Button
                            variant="primary"
                            data-testid="edit-button"
                            size="small"
                            onClick={() => onEditClick?.(row)}
                        >
                            Edit
                        </Button>
                        <button
                            type="button"
                            data-testid="delete-button"
                            className="icon-button-trash"
                            onClick={() => onDeleteClick?.(row)}
                        >
                            {/* bigger icon */}
                            <Trash className="ml-3 trash-icon" size={20} />
                        </button>
                    </div>
                ),
            },
        ],
        [onEditClick, onDeleteClick]
    );

    
    if (!data) {
        return;
    }
    return (
        <SortableTable
            data={data}
            columns={columns}
            isLoading={isLoading}
        />
    );
};

export default DeviceDataTable;
